<template>
  <v-container
    id="app-mobil-payment"
    class="pa-1"
  >
    <screen
      use-amount
      :title="title"
      :info="info"
      :titlesup="titleSup"
      :infosup="infoSup"
    />

    <keyboard-code
      :value="data"
      @input="input"
      @del="del"
      @cancel="cancel"
      @valid="valid"
    />
  </v-container>
</template>

<script>
import { Scan } from '@/modules/Scan'
import { MaxTryPinCode } from '@/modules/Enums'
import { $alert } from '@/modules/Utils'
import { Operations } from '@/modules/Operations'

export default {
  name: 'MobilPaymentView',

  props: {
    badge: { type: Object, default: null },
    total: { type: Number, default: 0 },
    products: { type: Array, default: () => [] },
    savedProducts: { type: Array, default: () => [] },
    reference: { type: String, default: null }
  },

  data () {
    return {
      usePin: false,
      useKilometers: false,
      pinBadge: null,
      //
      data: '',
      code: '',
      kilometers: '',
      try: 1
    }
  },

  computed: {
    title () {
      return this.pinBadge ? this.$i18n.t('field.mobil.pin') : this.useKilometers ? this.$i18n.t('field.mobil.km') : null
    },
    info () {
      return this.pinBadge ? this.display : this.useKilometers ? this.kilometers : null
    },
    titleSup () {
      return this.usePin ? null : (this.pinBadge ? (this.useKilometers ? this.$i18n.t('field.mobil.km') : null) : null)
    },
    infoSup () {
      return this.useKilometers ? this.kilometers : null
    },
    display () {
      return ''.padStart(this.code.length, '*')
    }
  },

  mounted () {
    if (this.badge === null) {
      this.$router.replace('/')
    } else {
      this.$emit('title', this.$i18n.t('title.mobil_payment'))

      // Check PIN mode
      if (typeof this.badge.PIN !== 'undefined' && this.badge.PIN !== '') {
        this.usePin = true
        this.pinBadge = this.badge.PIN
      }
      if (typeof this.badge.Kilometrage !== 'undefined' && this.badge.Kilometrage !== '0') {
        const labels = [
          'gas',
          'pétrole',
          'essence',
          'gasoil',
          'sans plomb'
        ]
        // On utilise les kilomètres si on a au moins un produit pétrolier
        this.useKilometers = this.savedProducts.findIndex(
          (product) => labels.findIndex(
            label => product.label.toLowerCase().includes(label)
          ) !== -1
        ) !== -1
      }

      // On envoi directement la requête car il n'y a rien à demander
      if (!this.usePin && !this.useKilometers) {
        this.sendRequest()
      }
    }
  },

  methods: {
    input (data) {
      this.data = data
      if (this.usePin) {
        this.code = data
      } else {
        this.kilometers = data
      }
    },
    del () {
      if (this.usePin) this.backToProducts()
    },
    cancel () {
      this.$router.replace('/home')
    },
    valid () {
      if (this.usePin) {
        if (this.data === this.pinBadge) {
          this.usePin = false
          this.code = this.data
          this.data = ''
          // Pas de kilometrage demandé
          if (!this.useKilometers) {
            this.sendRequest()
          }
        } else {
          if (this.try === MaxTryPinCode) {
            $alert(this.$i18n.t('error.bad_pin_max', { type: 'PIN' }))
            Operations.badgeOpposition(
              this.badge.IDBadge,
              () => {
                this.$router.replace('/home')
              },
              (error) => {
                $alert(error)
              }
            )
          } else {
            this.try++
            this.code = ''
            this.data = ''
            $alert(this.$i18n.t('error.bad_pin', { type: 'PIN', try: (MaxTryPinCode - this.try + 1) }))
          }
        }
      } else {
        if (this.useKilometers && this.kilometers === '') {
          $alert(this.$i18n.t('info.kilometers_required'), 'info')
        } else {
          this.sendRequest()
        }
      }
    },
    //
    sendRequest () {
      Scan.launchPmeDebitReponses(
        this.badge.IDBadge,
        this.products,
        (error) => {
          if (error) {
            $alert(error)
          }
          this.backToProducts()
        },
        this.kilometers,
        this.reference
      )
    },
    //
    backToProducts () {
      this.$router.replace({
        name: 'mobil-products',
        params: {
          badge: this.badge,
          previousTotal: this.total,
          previousList: this.products,
          previousListSaved: this.savedProducts,
          previousReference: this.reference
        }
      })
    }
  }
}
</script>
